import React, { useState } from "react"
import { css } from "@emotion/core"
import Section from "./section"
import ContactUsCSS from "../css/contact.module.css"

const Contact = () => {
  const [message, handleUpdateMessage] = useState({
    fullname: "",
    email: "",
    bodyMessage: "",
  })

  const handleUpdateState = e => {
    handleUpdateMessage({
      ...message,
      [e.target.name]: e.target.value,
    })
  }

  const { fullname, email, bodyMessage } = message

  const handleSubmitMessage = e => {
    e.preventDefault()

    handleUpdateMessage({
      fullname: "",
      email: "",
      bodyMessage: "",
    })
  }

  return (
    <>
      {/* <Section title="Contact Us"></Section> */}

      <section id="contacto" className={ContactUsCSS.contact}>
        <div className={ContactUsCSS.container}>
          <div className={ContactUsCSS.formBx}>
            {/* <form onSubmit={handleSubmitMessage}> */}
            <form
              action="https://getform.io/f/612ae219-5719-40d3-ac43-899e95dbe618"
              method="POST"
            >
              <h2>Contáctenos</h2>
              <div className={ContactUsCSS.inputBox}>
                <input
                  type="text"
                  name="fullname"
                  required="required"
                  onChange={handleUpdateState}
                  value={fullname}
                />
                <span>Nombre</span>
              </div>
              <div className={ContactUsCSS.inputBox}>
                <input
                  type="email"
                  name="email"
                  required="required"
                  onChange={handleUpdateState}
                  value={email}
                />
                <span>Email</span>
              </div>
              <div className={ContactUsCSS.inputBox}>
                <textarea
                  required="required"
                  name="bodyMessage"
                  onChange={handleUpdateState}
                  value={bodyMessage}
                ></textarea>
                <span>Mensaje</span>
              </div>
              <div className={ContactUsCSS.inputBox}>
                <input type="submit" value="Enviar" name="" />
              </div>
            </form>
          </div>
          <div className={ContactUsCSS.imgBx}></div>
        </div>
      </section>
    </>
  )
}

export default Contact
